export const radius300 = "4px";
export const radius900 = "999999px";
export const radiusRound = "999999px";
export const width0 = "0px";
export const width400 = "1px";
export const width500 = "2px";
export const colorNeutral = "#767676";
export const colorPrimary = "#247ddc";
export const colorDanger = "#a72929";
export const colorFocus = "#247ddc";
export const colorInvalid = "#247ddc";